import React, { useState, useRef, useEffect } from "react";
import "./AskAI.css";

const AskAi = ({ showChatButton = true }) => {
  const [isSplit, setIsSplit] = useState(false);
  const buttonRef = useRef(null);
  const [isGlowing, setIsGlowing] = useState(false);

  useEffect(() => {
    const glowInterval = setInterval(() => {
      setIsGlowing(true);
      setTimeout(() => setIsGlowing(false), 1500);
    }, 5000);

    return () => {
      clearInterval(glowInterval);
    };
  }, [isSplit]);

  const toggleSplit = () => {
    if (!showChatButton) {
      handleHelpFAQ();
      return;
    }
    setIsSplit(!isSplit);
  };
  const handleHelpFAQ = () => {
    if (typeof window !== "undefined" && window.toggleHelpGlobal) {
      window.toggleHelpGlobal();
      setIsSplit(false);
    } else {
      console.log("Help toggle function not available yet");
    }
  };

  const handleChatBot = () => {
    if (typeof window !== "undefined" && window.toggleAgentGlobal) {
      window.toggleAgentGlobal();
      setIsSplit(false);
    } else if (typeof window !== "undefined" && window.toggleChatBotGlobal) {
      window.toggleChatBotGlobal();
      setIsSplit(false);
    } else {
      console.log("Agent toggle function not available yet");
    }
  };
  return (
    <div className="ask-ai-container">
      {!isSplit ? (
        showChatButton ? (
          <button
            ref={buttonRef}
            className={`ask-ai-button ${isGlowing ? "glow-effect" : ""}`}
            onClick={toggleSplit}
          >
            <svg
              className="ai-icon"
              width="20"
              height="20"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 11.5C11.3978 11.5 11.7794 11.658 12.0607 11.9393C12.342 12.2206 12.5 12.6022 12.5 13C12.5 12.6022 12.658 12.2206 12.9393
                   11.9393C13.2206 11.658 13.6022 11.5 14 11.5C13.6022 11.5 13.2206 11.342 12.9393 11.0607C12.658 10.7794 12.5 10.3978 12.5 10C12.5
                   10.3978 12.342 10.7794 12.0607 11.0607C11.7794 11.342 11.3978 11.5 11 11.5ZM11 2.5C11.3978 2.5 11.7794 2.65804 12.0607 2.93934C12.342
                   3.22064 12.5 3.60218 12.5 4C12.5 3.60218 12.658 3.22064 12.9393 2.93934C13.2206 2.65804 13.6022 2.5 14 2.5C13.6022 2.5 13.2206 2.34196
                   12.9393 2.06066C12.658 1.77936 12.5 1.39782 12.5 1C12.5 1.39782 12.342 1.77936 12.0607 2.06066C11.7794 2.34196 11.3978 2.5 11 2.5ZM5.75
                   11.5C5.75 10.3065 6.22411 9.16193 7.06802 8.31802C7.91193 7.47411 9.05653 7 10.25 7C9.05653 7 7.91193 6.52589 7.06802 5.68198C6.22411
                   4.83807 5.75 3.69347 5.75 2.5C5.75 3.69347 5.27589 4.83807 4.43198 5.68198C3.58807 6.52589 2.44347 7 1.25 7C2.44347 7 3.58807 7.47411
                   4.43198 8.31802C5.27589 9.16193 5.75 10.3065 5.75 11.5Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="button-text">Ask AI</span>
          </button>
        ) : (
          <button
            className="ask-ai-button"
            onClick={handleHelpFAQ}
          >
            <svg
              className="split-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19.5C7.86 19.5 4.5 16.14 4.5 12C4.5 7.86 7.86 4.5 12 4.5C16.14 4.5 19.5 7.86 19.5 12C19.5 16.14 16.14 19.5 12 19.5ZM14.3 7.7C14.91 8.31 15.25 9.13 15.25 10C15.25 10.87 14.91 11.68 14.3 12.3C13.87 12.73 13.33 13.03 12.75 13.16V13.5C12.75 13.91 12.41 14.25 12 14.25C11.59 14.25 11.25 13.91 11.25 13.5V12.5C11.25 12.09 11.59 11.75 12 11.75C12.47 11.75 12.91 11.57 13.24 11.24C13.57 10.91 13.75 10.47 13.75 10C13.75 9.53 13.57 9.09 13.24 8.76C12.58 8.1 11.43 8.1 10.77 8.76C10.44 9.09 10.26 9.53 10.26 10C10.26 10.41 9.92 10.75 9.51 10.75C9.1 10.75 8.76 10.41 8.76 10C8.76 9.13 9.1 8.32 9.71 7.7C10.94 6.47 13.08 6.47 14.31 7.7H14.3ZM13 16.25C13 16.8 12.55 17.25 12 17.25C11.45 17.25 11 16.8 11 16.25C11 15.7 11.45 15.25 12 15.25C12.55 15.25 13 15.7 13 16.25Z"
                fill="#ffffff"
              />
            </svg>
            <span className="button-text">Help</span>
          </button>
        )
      ) : (
        <>
          <button
            className={`split-button help ${isSplit ? "visible" : ""}`}
            onClick={handleHelpFAQ}
          >
            <svg
              className="split-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19.5C7.86 19.5 4.5 16.14 4.5 12C4.5 7.86 7.86 4.5 12 4.5C16.14 4.5 19.5 7.86 19.5 12C19.5 16.14 16.14 19.5 12 19.5ZM14.3 7.7C14.91 8.31 15.25 9.13 15.25 10C15.25 10.87 14.91 11.68 14.3 12.3C13.87 12.73 13.33 13.03 12.75 13.16V13.5C12.75 13.91 12.41 14.25 12 14.25C11.59 14.25 11.25 13.91 11.25 13.5V12.5C11.25 12.09 11.59 11.75 12 11.75C12.47 11.75 12.91 11.57 13.24 11.24C13.57 10.91 13.75 10.47 13.75 10C13.75 9.53 13.57 9.09 13.24 8.76C12.58 8.1 11.43 8.1 10.77 8.76C10.44 9.09 10.26 9.53 10.26 10C10.26 10.41 9.92 10.75 9.51 10.75C9.1 10.75 8.76 10.41 8.76 10C8.76 9.13 9.1 8.32 9.71 7.7C10.94 6.47 13.08 6.47 14.31 7.7H14.3ZM13 16.25C13 16.8 12.55 17.25 12 17.25C11.45 17.25 11 16.8 11 16.25C11 15.7 11.45 15.25 12 15.25C12.55 15.25 13 15.7 13 16.25Z"
                fill="#ffffff"
              />
            </svg>
            <span className="button-text">Help</span>
          </button>

          <button
            className={`close-ai-button ${isSplit ? "visible" : ""}`}
            onClick={toggleSplit}
          >
            <svg
              className="close-ai-icon"
              viewBox="0 0 24 24"
              width={28}
              height={28}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#ffffff"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {showChatButton && (
            <button
              className={`split-button chat ${isSplit ? "visible" : ""}`}
              onClick={handleChatBot}
            >
              <svg
                className="split-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16ZM7 9H9V11H7V9ZM11 9H13V11H11V9ZM15 9H17V11H15V9Z"
                  fill="#ffffff"
                />
              </svg>
              <span className="button-text">Chat</span>
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default AskAi;
